import React, { useEffect, useState } from 'react';
import filtro from '../assets/Filter.png';
import search from '../assets/search.png';
import axios from '../axiosConfig';
import { handleError, toastError } from '../funciones';

function Encabezado(props) {

    const [eventos, setEventos] = useState([]);

    useEffect(() => {
        const params = {
            params: {
                empresaId: localStorage.getItem(process.env.REACT_APP_ID_EMPRESA)
            }
        }
        axios
            .get(process.env.REACT_APP_URL + 'inscripcion/inscripcionesAEventosQueNoPasaronDeUnaEmpresa', params)
            .then(function (response) {
                setEventos(response.data);
                if (response.data.length !== 0)
                    props.setIdInscripcion(response.data[0].id)
            })
            .catch(function (error) {
                toastError(handleError(error))
            });
    }, [])

    function cambiarSelectValue(e) {
        props.setIdInscripcion(e.value)
    }

    function mostrarFiltros() {
        document.getElementById("containerFiltros").classList.remove("ocultarFiltros")
        document.getElementById("filtroOverlay").classList.remove("ocultarFiltros")
    }

    function imprimir() {
        window.print();
    }

    return (
        <>
            <div id="encabezado" className='row align-items-center'>
                {props.seccionId === 2 ?
                    <div className='col-sm-5 col-12'>


                        {eventos.length !== 0 ?
                            <select onChange={e => cambiarSelectValue(e.target)} class="form-select select-normal py-3 
                        py-sm-4 text-white titulos selectEncabezado fs-5 ps-0 white-space-wrap" aria-label="Default select example">
                                {eventos.map(function (elem) {
                                    return (
                                        <option value={elem.id}>{elem.nombreEvento + " " + elem.fechaEvento}</option>
                                    )
                                })
                                }
                            </select>
                            :
                            <select onChange={e => cambiarSelectValue(e.target)} class="form-select py-3 py-sm-4 text-white titulos 
                        bg-transparent selectEncabezado fs-5 select-normal ps-0 white-space-wrap" aria-label="Default select example" disabled>
                                <option>No se encontraron eventos</option>
                            </select>
                        }
                    </div>
                    :
                    <div className='col-sm-7 col-6'>

                        <h1 className='py-3 py-sm-4 text-white titulos'>Mis actividades</h1>

                    </div>
                }
                <div id="botonBuscarCompleto" className={props.seccionId === 2 ? 'col pb-3 pb-sm-0  pe-0' : 'col-12 col-sm pb-3 pb-sm-0'}>

                    <div className={props.seccionId === 2 ? 'rounded-4 bg-white ps-1 centrarContainer  ' //botonBuscarCompleto
                        : 'rounded-4 ms-auto  bg-white ps-1 centrarContainer mb-sm-2 text-end' /*botonBuscarCompleto*/}>
                        <img className='mx-2' src={search} alt="" />
                        <input id='buscarText' class="ps-0 form-control form-normal rounded-4 border-0 bold-botones botonBuscar d-inline-block "
                            type="text" placeholder="Buscar" aria-label="Buscar"
                            value={props.search}
                            onChange={(e) => props.setSearch(e.target.value)}/>

                    </div>

                </div>
                {props.seccionId === 2 ?
                    <>
                        <div className='col-3 text-end ps-5 col-sm-2 pb-3 pb-sm-0  w-fit-content '>
                            <div class=" nav-item dropdown  py-2 px-3 d-inline-block bg-white rounded-3 " onClick={mostrarFiltros}>
                                <a class="nav-link dropdown-toggle centrarContainer bold-botones px-0 " href="#">
                                    <img className='me-2 ' src={filtro} alt="" />
                                    Filtros
                                </a>
                                {/*<ul class="dropdown-menu"> 
                                <li><a class="dropdown-item" href="#">Rubro</a></li>
                                <li><a class="dropdown-item" href="#">Unión Industrial</a></li>
                            </ul>*/}
                            </div>
                        </div>
                    </>
                    :
                    <>
                        {/*<div id='btnImprimir' className='col-2 text-end ps-0 d-none'>  
                        <img className='logoImprimir mb-2' src={impresora} alt="" onClick={()=>imprimir()}/>
                    </div>  */}
                        <div id='btnImprimir' className='col text-end ps-0 d-none mb-2 text-end'>
                            <div className='d-inline-block'>
                                <button class="btnImprimir btn btn-outline-secondary bold-botones centrarContainer btn-cuadrado"
                                    onClick={() => imprimir()}>
                                    <div className='text-imprimir'> Imprimir reuniones</div>
                                    <div className='text-imprimir-mobile d-none'>Imprimir</div>
                                    <div className='logoImprimir ms-2' alt="" />
                                </button>  </div>
                        </div>
                    </>
                }
            </div>
        </>
    );
}


export default Encabezado;